import Cookies from "js-cookie";
import axios from "axios";
import { nanoid } from "nanoid";

export default class VoteAPI {
    constructor() {
        this._init();
    }

    send(data, callback) {
        this.userForm.series = this._getSeriesStr(data.key);
        this.userForm.title = data.title;
        this.userForm.no = data.storyNo;
        this.userForm.id = `${data.key}_${data.storyNo}`;
        this.callback = callback;

        this.isExtra = data.key === "extra" ? true : false;

        this._sendFormData();
    }

    _init() {
        this.$submit = document.querySelector(".vmodal__ui__item.-submit");
        this.$voted = document.querySelector(".vmodal__ui__item.-voted");
        this.$reset = document.querySelector(".vmodal__ui__item.-reset");

        this.userForm = {
            id: null, // ID番号(連番)
            no: null, // STORY NO
            title: null, // 各話タイトル
            uid: this._getUid(),
        };

        this.daylimit = false;
        this.callback = null;

        this._isDaylimit();
    }

    /**
     * シリーズ名を取得
     */
    _getSeriesStr(key) {
        const seriesList = {
            sao1: "SWORD ART ONLINE",
            sao2: "SWORD ART ONLINE II",
            extra: "SWORD ART ONLINE EXTRA EDITION",
            alicization: "SWORD ART ONLINE ALICIZATION",
            wou: "SWORD ART ONLINE ALICIZATION WAR OF UNDERWORLD",
        };

        return seriesList[key];
    }

    /**
     * @returns uidを取得
     */
    _getUid() {
        let uid;

        if (Cookies.get("uid")) {
            uid = Cookies.get("uid");
        } else {
            uid = nanoid();
            Cookies.set("uid", uid, { expires: this._getTodayExpires() });
        }

        return uid;
    }

    _getTodayExpires() {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    }

    /**
     * 回数制限
     */
    _isDaylimit() {
        if (Cookies.get("daylimit")) {
            this.daylimit = true;
            this._setBtnOff();
        }
    }

    _setDayLimit() {
        Cookies.set("daylimit", 1, { expires: this._getTodayExpires() });
        this._setBtnOff();
    }

    _setBtnOff() {
        this.$submit.style.pointerEvents = 'none';

        setTimeout(()=>{
            this.$submit.classList.add("-disable");
            this.$voted.classList.remove("-disable");
            this.$reset.classList.add("-disable");
        }, 600);
    }

    /**
     * フォームデータを送信
     */
    _sendFormData() {
        const postdata = {
            type: "web",
            uid: this.userForm.uid,
            chr: this.userForm.id,
        };

        this._sendToAPI(postdata, () => {
            //console.log(postdata);
            this._setDayLimit();
            this._setTwitter();
            if (this.callback) this.callback();
        });
    }

    _sendToAPI(data, callback) {
        const URL = "./api.html";

        const payload = new FormData();
        payload.append("type", data.type);
        payload.append("uid", data.uid);
        payload.append("chr", data.chr);

        axios.post(URL, payload).then((res) => {
            //console.log(res);
            callback && callback(res);
        });
    }

    /**
     * Twitterを設定する
     */
    _setTwitter() {
        const title = this.isExtra ? "" : ` #${this.userForm.no}「${this.userForm.title}」`;
        const twtxt = encodeURIComponent(
            `${this.userForm.series + title}\n\nユーザー投票で決定！\n「SAO SELECTION」2022.7 ON AIR 決定\nhttps://sao10th.net/vote/?type=${this.userForm.id}\n #sao_anime`
        );

        const $twitter = document.querySelector(".vmodal__ui__item.-twitter a");
        $twitter.setAttribute("href", `https://twitter.com/intent/tweet?text=${twtxt}`);
    }
}
